import { Activity, Briefcase, CalendarDays, CalendarOff, CalendarPlus, ClipboardList, Clock, FileText, FileWarning, FolderOpen, LayoutDashboard, Megaphone, Receipt, ShieldCheck, UserCircle, Users, Wallet } from 'lucide-react';
import '../styles/pageHeading.css';

const icons = { activity: Activity, orders: Briefcase, planning: CalendarDays, absences: CalendarOff, extensions: CalendarPlus, register: ClipboardList, hours: Clock, contracts: FileText, documents: FileWarning, library: FolderOpen, dashboard: LayoutDashboard, announcements: Megaphone, invoices: Receipt, atradius: ShieldCheck, account: UserCircle, clients: Users, candidates: Users, advances: Wallet };

const colors = { dashboard: 'blue', clients: 'blue', candidates: 'pink', contracts: 'purple', invoices: 'gold', planning: 'cyan', activity: 'pink', orders: 'purple', announcements: 'pink', absences: 'purple', extensions: 'cyan', register: 'cyan', hours: 'blue', documents: 'gold', library: 'purple', atradius: 'gold', account: 'blue', advances: 'gold' };

export default function PageHeading({ title, description, icon = 'activity', level = 1, color }) {
  const Icon = icons[icon] || Activity;
  const Heading = level === 2 ? 'h2' : 'h1';
  return <div className="jm-page-heading" data-color={color || colors[icon] || 'blue'}>
    <div className="jm-page-heading-icon" aria-hidden="true"><Icon /></div>
    <div className="jm-page-heading-copy">
      <Heading className="jm-page-heading-title">{title}</Heading>
      {description && <p className="jm-page-heading-description">{description}</p>}
    </div>
  </div>;
}
